/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Added_To_CartInputs */

const en_added_to_cart = /** @type {(inputs: Added_To_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added to basket!`)
};

const es_added_to_cart = /** @type {(inputs: Added_To_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Añadido a la cesta!`)
};

const fr_added_to_cart = /** @type {(inputs: Added_To_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouté au panier !`)
};

const de_added_to_cart = /** @type {(inputs: Added_To_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Warenkorb hinzugefügt!`)
};

const id_added_to_cart = /** @type {(inputs: Added_To_CartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditambahkan ke keranjang!`)
};

/** @type {(inputs: Added_To_CartInputs) => LocalizedString} */
const ja_added_to_cart = en_added_to_cart;

/** @type {(inputs: Added_To_CartInputs) => LocalizedString} */
const zh_added_to_cart = en_added_to_cart;

/** @type {(inputs: Added_To_CartInputs) => LocalizedString} */
const ar_added_to_cart = en_added_to_cart;

/** @type {(inputs: Added_To_CartInputs) => LocalizedString} */
const it_added_to_cart = en_added_to_cart;

/** @type {(inputs: Added_To_CartInputs) => LocalizedString} */
const ru_added_to_cart = en_added_to_cart;

/** @type {(inputs: Added_To_CartInputs) => LocalizedString} */
const pt_added_to_cart = en_added_to_cart;

/** @type {(inputs: Added_To_CartInputs) => LocalizedString} */
const ko_added_to_cart = en_added_to_cart;

/**
* | output |
* | --- |
* | "Added to basket!" |
*
* @param {Added_To_CartInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const added_to_cart = /** @type {((inputs?: Added_To_CartInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Added_To_CartInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_added_to_cart(inputs)
	if (locale === "es") return es_added_to_cart(inputs)
	if (locale === "fr") return fr_added_to_cart(inputs)
	if (locale === "de") return de_added_to_cart(inputs)
	if (locale === "ja") return ja_added_to_cart(inputs)
	if (locale === "zh") return zh_added_to_cart(inputs)
	if (locale === "ar") return ar_added_to_cart(inputs)
	if (locale === "id") return id_added_to_cart(inputs)
	if (locale === "it") return it_added_to_cart(inputs)
	if (locale === "ru") return ru_added_to_cart(inputs)
	if (locale === "pt") return pt_added_to_cart(inputs)
	return ko_added_to_cart(inputs)
});